"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LocallySourced = createSVGIcon(
  <>
    <path d="m14.553 18.01-.053-8" stroke="#D5BF9B" strokeWidth="3" />
    <path d="M4.5 18V5m5 13V5m10 13V5" stroke="#312921" />
  </>,
  "Locally sourced",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Locally Sourced",
    fill: "none",
  }
);
